module.exports = __webpack_public_path__ + "static/media/lloyd.b50034cf.jpg";